import request from "@/router/axios"
export const getPatientInfo = (patientId) => {
    return request({
        url: `/api/basis/patient/getPatientInfo`,
        method: 'get',
        params: {
            patientId
        }
    })
}
export const getPatient = (identityType, identityNo) => {
    return request({
        url: `/api/basis/patient/getPatient`,
        method: 'get',
        params: {
            identityType: identityType,
            identityNo: identityNo
        },
    })
}